// extracted by mini-css-extract-plugin
module.exports = {"contents":"wd-z","sectionHeading":"xd-z"};